export default __webpack_public_path__ + "static/media/service-7.1c4d5e99.jpg";